import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import CarInfoShimmer from "@/pages/checkout/components/HeadingSteps/MobileCarInfo/CarInfoShimmer";
import CreditCardInfoShimmer from "@/pages/checkout/CheckoutV2/components/CreditCardInfoShimmer";
// Common layout for both payment form shimmer variants
var PaymentFormShimmer = function PaymentFormShimmer(_ref) {
  var appearance = _ref.appearance;
  var variant = (appearance === null || appearance === void 0 ? void 0 : appearance.variant) || "full";
  var color = (appearance === null || appearance === void 0 ? void 0 : appearance.color) || "gray";
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full",
    style: {
      height: "auto",
      minHeight: variant === "full" ? "930px" : "700px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-5"
  }, /*#__PURE__*/React.createElement(CarInfoShimmer, {
    variant: variant
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-8"
  }, /*#__PURE__*/React.createElement(CreditCardInfoShimmer, {
    color: color
  })), variant === "full" && /*#__PURE__*/React.createElement("div", {
    className: "mt-[140px]"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 60,
    divWidth: "100%",
    appearance: {
      color: "green"
    }
  })), variant === "compact" && /*#__PURE__*/React.createElement("div", {
    className: "mt-[200px]"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 60,
    divWidth: "100%",
    appearance: {
      color: "green"
    }
  }))));
};

// Full version export
export var FullPaymentFormShimmer = function FullPaymentFormShimmer(props) {
  return /*#__PURE__*/React.createElement(PaymentFormShimmer, _extends({}, props, {
    appearance: _objectSpread(_objectSpread({}, props.appearance), {}, {
      variant: "full"
    })
  }));
};

// Compact version export
export var CompactPaymentFormShimmer = function CompactPaymentFormShimmer(props) {
  return /*#__PURE__*/React.createElement(PaymentFormShimmer, _extends({}, props, {
    appearance: _objectSpread(_objectSpread({}, props.appearance), {}, {
      variant: "compact"
    })
  }));
};
export default PaymentFormShimmer;